var disableBodyScroll = require( '../util/disableBodyScroll' );

const navJS = {};

navJS.navToggle = () => {
  const el = document.querySelector('.js-nav-toggle');
  const elHtml = document.querySelector('html');
  const elNav = document.querySelector('.js-nav');

  el.addEventListener('click', function () {

    const parentEl = document.querySelector('.navbar');

    if (parentEl.classList.contains('submenu-open') && parentEl.classList.contains('is-open')) {

      parentEl.classList.add('hide-submenu');

      setTimeout(function () {
        elHtml.classList.toggle('is-fixed');
        parentEl.classList.toggle('is-open');

        if (parentEl.classList.contains('is-open')) {
          disableBodyScroll(true, '.js-nav');
        }
        else {
          disableBodyScroll(false, '.js-nav');
        }

      }, 200);

      setTimeout(function () {
        parentEl.classList.remove('submenu-open');
      }, 600);
    }
    else {
      parentEl.classList.remove('hide-submenu');
      elHtml.classList.toggle('is-fixed');
      parentEl.classList.toggle('is-open');
      if (parentEl.classList.contains('is-open')) {
        disableBodyScroll(true, '.js-nav');
      }
      else {
        disableBodyScroll(false, '.js-nav');
      }

    }
  })


};

navJS.submenuToggle = () => {
  const elems = document.querySelectorAll('.js-submenu-toggle');
  const parentEl = document.querySelector('.navbar');
  const navBtnPos = document.querySelector('.nav-start');

  for (var i = 0; i < elems.length; i++) {
    elems[i].addEventListener('click', function (event) {
      event.preventDefault();
      parentEl.classList.add('submenu-open');
      this.parentElement.querySelector('.submenu-links').classList.add('is-open');
    });
  }
};

navJS.submenuBackToggle = () => {
  const bckBtn = document.querySelectorAll('.js-submenu-back-toggle');
  const parentEl = document.querySelector('.navbar');

  for (var i = 0; i < bckBtn.length; i++) {
    bckBtn[i].addEventListener('click', function (event) {
      this.parentElement.parentElement.classList.remove('is-open');
      parentEl.classList.remove('submenu-open');
    });
  }
};

navJS.labelSubmenuToggle = () => {
  const label = document.querySelectorAll('.js-label-toggle');
  for (var i = 0; i < label.length; i++) {
    label[i].addEventListener('click', function (event) {
      const button = $(this).parent().find('.js-submenu-toggle');
      button.trigger('click');
    });
  }
};

navJS.swipeMobile = () => {
  const elems = document.querySelectorAll('.js-nav-btn-title');

  for (var i = 0; i < elems.length; i++) {
    const button = elems[i].querySelectorAll('.nav-btn');
    navJS.swipeMobileBtn(button);
  }

  var myElement = document.getElementById('js-swiper');
  var mc = new Hammer(myElement);
  mc.on("panleft panright tap press", function (ev) {

    const buttonTrigger = document.querySelector('.js-nav-btn-title').querySelectorAll('.nav-btn');

    if(ev.type === 'panleft') {
      buttonTrigger[1].click();
    }
    else if(ev.type === 'panright') {
      buttonTrigger[0].click();
    }
  });
};

navJS.swipeMobileBtn = (btnElem) => {
  for (var i = 0; i < btnElem.length; i++) {
    const num = i;
    btnElem[i].addEventListener('click', function (event) {
      navJS.removeClass(btnElem);
      this.classList.add('is-active');

      const elemClose = document.querySelector('.nav-left');

      if(num === 1) {
        elemClose.classList.add('is-close');
      }
      else {
        elemClose.classList.remove('is-close');
      }
    });
  }
};

navJS.removeClass = (classRemove) => {
  for (var i = 0; i < classRemove.length; i++) {
    classRemove[i].classList.remove('is-active');
  }
};

navJS.init = () => {
  navJS.navToggle();
  navJS.submenuToggle();
  navJS.submenuBackToggle();
  navJS.labelSubmenuToggle();
  navJS.swipeMobile();
};


document.addEventListener('DOMContentLoaded', function (event) {
  navJS.init();
});


// WEBPACK FOOTER //
// ./scripts/components/nav.js